import { FC } from "react";
import { Box, Theme } from "@mui/material";
import { Modal, ModalProps } from "@vilocnv/allsetra-core";
import { useTranslation } from "react-i18next";
import { KeyHistoryEntryDto } from "domain/keys/entities/dtos/key-history.dto";
import KeyHistoryTable from "../KeyHistoryTable";

export type KeyHistoryModalProps = Pick<ModalProps, "open" | "onClose"> & {
  theme: Theme;
  historyData: KeyHistoryEntryDto[];
  loading?: boolean;
  keyLabel?: string;
};

const KeyHistoryModal: FC<KeyHistoryModalProps> = ({
  open,
  onClose,
  theme,
  historyData,
  loading = false,
  keyLabel
}) => {
  const { t } = useTranslation(["translation"]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`${t("keyHistory.title")}${keyLabel ? ` - ${keyLabel}` : ""}`}
      primaryBtnProps={{
        text: t("buttonsText.close"),
        onClick: onClose
      }}
      secondaryBtnProps={{
        text: "",
        sx: { display: "none" }
      }}
      theme={theme}
      size="large"
    >
      <Box
        sx={{
          minWidth: 900,
          width: "100%",
          minHeight: 200,
          maxHeight: 400,
          overflow: "auto"
        }}
      >
        <KeyHistoryTable historyData={historyData} loading={loading} />
      </Box>
    </Modal>
  );
};

export default KeyHistoryModal;
